import Components__DialogController from '../components/dialog_controller'

// Connects to data-controller="utils--select-modal"
export default class extends Components__DialogController {
  static targets = ['fieldValue', 'fieldLabel', 'fieldValueSelect']


  openDialog(event) {
    super.openDialog(event)
    this.fieldValueSelectTarget.value = this.fieldValueTarget.value
  }

  setValue(event) {
    const selectedOption = event.target.options[event.target.selectedIndex]
    const value = selectedOption.value
    const label = selectedOption.text

    this.fieldValueTarget.value = value
    this.fieldLabelTarget.innerHTML = label
    this.closeDialog();
  }
}
